import { ChangeDetectionStrategy, Component, computed } from '@angular/core'

import { CardPublication } from 'app/core/cms/generated/api-types'
import { PublicationItemCardComponent } from 'app/shared/publication-item-card/publication-item-card.component'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-card-publication',
  templateUrl: './card-publication.component.html',
  styleUrls: ['./card-publication.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PublicationItemCardComponent],
  providers: [{ provide: CmsBlock, useExisting: CardPublicationComponent }],
})
export class CardPublicationComponent extends CmsBlock<CardPublication> {
  readonly __typename = 'CardPublication'
  protected readonly publication = computed(() => this.data().item)
}
